import { useEffect, useState } from "react";
import CONFIGURACIONES from "../../../util/constants";
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { Functions } from "../../../helpers/Functions.jsx";
import { useLocation, useOutletContext } from "react-router-dom";
import { Http } from "../../../helpers/Http.jsx";
import {useZonaAgencia} from "../../context/ZonaAgenciaContext.jsx";
import MantApprovalRate from "./components/MantApprovalRate.jsx";
const MySwal = withReactContent(Swal);

const PageApprovalRate = () => {
    const location = useLocation();
    
    const [isRenderList, setIsRenderList] = useState(CONFIGURACIONES.INIT.STATUS_RENDER_LIST);
    const [idRef, setIdRef] = useState(CONFIGURACIONES.INIT.ID_EDIT);
    const [itemSelected, setItemSelected] = useState(CONFIGURACIONES.INIT.NULL);

    const [iconActive, setIconActive] = useState(CONFIGURACIONES.INIT.STRING);
    const [isStepEvaluation02, setIsStepEvaluation02] = useState(CONFIGURACIONES.INIT.STATUS_FALSE);
    const [itemSaved, setItemSaved] = useState(CONFIGURACIONES.INIT.NULL);

    const [listSolicitudes, setListSolicitudes] = useState(CONFIGURACIONES.INIT.ARRAY);
    const { getUser } = useOutletContext();
    const { showSpinnerLoader } = useOutletContext();
    const { zona, agencia} = useZonaAgencia();

    const createApproval = async (form) => {
        if (!searchPermissions(CONFIGURACIONES.ACTIONS.CREAR)) { return; }
        await Functions().saveApproval(`${CONFIGURACIONES.ENDPOINTS.SOLICITUDES}/operar/${itemSelected.id}`, getUser(), searchData, CONFIGURACIONES.INIT.NULL, form);
    };

    const searchPermissions = (action) => {
        let permisoStorage = localStorage.getItem('option_id');
        let tienePermiso = CONFIGURACIONES.INIT.STATUS_FALSE
        if (permisoStorage) {
            let permiso_id = Functions().decryptData(permisoStorage);
            tienePermiso = Functions().searchPermissions(permiso_id, action, getUser().permisos);
        }
        
        return tienePermiso;       
    };

    const searchData = () => {
        if (!zona || !agencia) { return; }

        showSpinnerLoader();
        let data = {
            body: {
                'agenciaId': agencia,
                'zonaId': zona,
                'usuarioRegistro': getUser().user,
            }
        }
        setListSolicitudes(CONFIGURACIONES.INIT.ARRAY);
        Http().post(`${CONFIGURACIONES.ENDPOINTS.SOLICITUDES}/aprobacion-tasa/buscar`, data).then((rpta) => {
            if (rpta.status === CONFIGURACIONES.RESPONSES.SUCCESS) {
                setListSolicitudes(rpta.data);
            }
        });
    }

    useEffect(() => {
        const icon = localStorage.getItem('icon_active');
        if (icon) {
            const icon_decrypt = Functions().decryptData(icon);
            setIconActive(icon_decrypt);
        }
        setItemSelected(CONFIGURACIONES.INIT.NULL);
    }, []); // se ejecuta una vez al montar

    useEffect(() => {
        if (!searchPermissions(CONFIGURACIONES.ACTIONS.MOSTRAR)) { return; }
        
        showSpinnerLoader();
        // loadData();
        let segments = location.pathname.split("/");
        let lastSegment = segments[segments.length - 1];
        setIsStepEvaluation02(lastSegment === 'step-02'?CONFIGURACIONES.INIT.STATUS_TRUE: CONFIGURACIONES.INIT.STATUS_FALSE);
        console.log('lastSegment', lastSegment);

        // loadData();
        setIsRenderList(CONFIGURACIONES.INIT.STATUS_RENDER_LIST);
        // console.log(`result: ${lastSegment === 'new' || (!isNaN(lastSegment) && lastSegment !== '')}`);
        // console.log('componentes', componentes);
        
    }, [location.pathname])

    useEffect(() => {
        searchData()
    }, [zona, agencia]);

    return (
        <div className="content-wrapper">
            <div className="content-body"> 
                <div className="row">
                    {isRenderList && (
                        <div className="col-lg-10 col-md-12 col-xs-12">
                            <div className="card">
                                <div className="card-body">
                                    {!isStepEvaluation02 && <MantApprovalRate title={'Bandeja de Aprobación de Tasa'} idEdit={idRef} MySwal={MySwal}
                                        icon={iconActive} user={getUser()} showSpinnerLoader={showSpinnerLoader}
                                        setIdRef={setIdRef} fnCrear={createApproval} showCreate={searchPermissions(CONFIGURACIONES.ACTIONS.CREAR)}
                                        showDelete={searchPermissions(CONFIGURACIONES.ACTIONS.ELIMINAR)}
                                        zona={zona} agencia={agencia} list={listSolicitudes} setItemSelected={setItemSelected} />}

                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}

export default PageApprovalRate;